import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Badge, Button, Table, Progress } from "reactstrap";
import "../../assets/css/--page-order-track.css"
import { useNavigate, useParams } from "react-router-dom";
import imageDone from '../../assets/images/step-done.png'
import imagePending from '../../assets/images/step-pending.png'
import imageUpcoming from '../../assets/images/step-upcoming.png'
import { getTrackinglist, formatTime, orderTimeDiff } from "../../helper/backend-methods";
import statuses from "../../data/statuses";
import AppLoader from "../../components/AppLoader";
import { onOrderStatusUpdate } from "../../helper/signalr-service";

function TrackOrder(props) {
    let params = useParams();
    const orderID = params.id
    const history = useNavigate()
    const [loading, setLoading] = useState(true)
    const [orderTrack, setOrderTrack] = useState([])
    const orderProgress = [
        {
            key: "preparing",
            title: "Order Received & Preparing",
            description: "",
            time: "-",
            status: "upcoming",
            icon: imageUpcoming,
        },
        {
            key: "ready_pickup",
            title: "Ready For Pickup",
            description: "",
            time: "-",
            status: "upcoming",
            icon: imageUpcoming,
        },
        {
            key: "pickup",
            title: "Order Picked Up",
            description: "",
            time: "-",
            status: "upcoming",
            icon: imageUpcoming,
        },
    ];

    const setUpProgress = (order) => {
        if (order.CurrentStatus === "Preparing" || order.CurrentStatus === "Ready For Pickup" || order.CurrentStatus === "Order Picked Up") {
            orderProgress.filter(p => p.key === "ready_pickup")[0].icon = imagePending;
            let p = orderProgress.filter(p => p.key === "preparing")[0];
            p.description = statuses.Preparing.message;
            p.done = true;
            p.completed = true;
            p.status = "completed";
            p.icon = imageDone;
            p.time = formatTime(order.OrderPreparingAt)

        }
        if (order.CurrentStatus === "Ready For Pickup" || order.CurrentStatus === "Order Picked Up") {
            orderProgress.filter(p => p.key === "pickup")[0].icon = imagePending;
            let p = orderProgress.filter(p => p.key === "ready_pickup")[0];
            p.description = statuses.ReadyForPickup.message;
            p.done = true;
            p.completed = true;
            p.status = "completed";
            p.icon = imageDone;
            p.time = formatTime(order.ReadyForPickupAt)
        }
        if (order.CurrentStatus === "Order Picked Up") {
            let p = orderProgress.filter(p => p.key === "pickup")[0];
            p.done = true;
            p.description = statuses.OrderPickedUp.message;
            p.time = formatTime(order.OrderPickedUpAt)
            p.completed = true;
            p.status = "completed";
            p.icon = imageDone;
        }
        return orderProgress;
    }

    onOrderStatusUpdate((response) => {
        getOrder();
    });

    const getOrder = () => {
        getTrackinglist({ orderId: orderID }).then(({ data }) => {
            if (data.Status) {
                data.Data.progress = setUpProgress(data.Data);
                setOrderTrack(data.Data);
                setLoading(false)
            }
        }).catch((e) => {
            console.log(e);
            setLoading(false)
        });
    }

    useEffect(() => {
        getOrder();
    }, []);
    
    return (
        <>
            {loading ? <div className="loader-center ">
                <AppLoader />
            </div> :
                <div id="order-tracking-main-container" className="mt-5 ms-4">
                    <div className="d-flex align-items-center mb-4 order-heading">
                        <h1 className="fs-30 text-blakish fw-600 m-0">Current Orders</h1>
                        <i className="ri-arrow-right-double-fill fs-30"></i>
                        <h1 className="fs-30 fw-600 m-0 red-link">Order Tracking</h1>
                    </div>
                    <span className="separator mt-4 mb-3"></span>
                    <div className="order-tracking-container">
                        <Row className="equal-height-row">
                            {/* Left Column */}
                            <Col lg={8} md={12}>
                                <div className="order-details-card">
                                    <CardBody>
                                        {/* Header */}
                                        <div className="d-flex justify-content-between flex-wrap align-items-center mb-3 track-order-header order-receive-details">
                                            <div>
                                                <div className="text-black fs-18">Order No.</div>
                                                <div className="text-gray fs-18">#{orderTrack.OrderNo}</div>
                                            </div>
                                            <div>
                                                <div className="text-black fs-18">Status</div>
                                                <span className={`status-badge ${orderTrack?.CurrentStatus?.toLowerCase().replace(/\s/g, "")}`}>{orderTrack?.CurrentStatus}</span>
                                            </div>
                                            <div>
                                                <div className="text-black fs-18">Estimated Pickup Time</div>
                                                <div className="text-gray fs-18">{orderTrack?.Status === "Preparing" ? orderTimeDiff({ startTime: orderTrack?.OrderPreparingAt, endTime: orderTrack?.EstimatedEndTime, leverages: orderTrack?.OrderLeverage }) : orderTrack?.Status === "ReadyForPickup" ? orderTimeDiff({ startTime: orderTrack?.EstimatedEndTime, endTime: orderTrack?.EstimatedEndTime, leverages: orderTrack?.OrderLeverage }) : orderTimeDiff({ startTime: orderTrack?.EstimatedStartTime, endTime: orderTrack?.EstimatedEndTime, leverages: orderTrack?.OrderLeverage })}</div>
                                            </div>
                                        </div>

                                        {/* Order Progress */}
                                        <div className="mt-4">
                                            <h4 className="mb-1 fs-24 text-blakish">Order Progress</h4>
                                            <div className="text-gray mb-4 fs-18">Track your order in real-time.</div>

                                            <div className="progress-timeline">
                                                {orderTrack?.progress?.map((step, idx) => (
                                                    <div
                                                        key={idx}
                                                        className={`timeline-step ${step.status} w-100`}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <div className="d-flex">
                                                                <div className="icon-wrapper">
                                                                    <img src={step.icon} alt="" className="step-icon" />
                                                                    {idx !== orderTrack?.progress?.length - 1 && (
                                                                        <div className="connector" />
                                                                    )}
                                                                </div>
                                                                <div>
                                                                    <div
                                                                        className={`fs-18 fw-500 ${step.status === "ongoing" ? "text-ongoing" : step.status === "completed" ? "text-done" : "text-upcoming"}`}
                                                                    >
                                                                        {step.title}
                                                                    </div>
                                                                    <div className="text-gray fs-16">{step.description}</div>
                                                                </div>
                                                            </div>
                                                            <div className="text-gray fs-16">{step.time}</div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </CardBody>
                                </div>
                            </Col>

                            {/* Right Column */}
                            <Col lg={4} md={12} className="track-order-summary">
                                {/* Order Summary */}
                                <div className="order-summary-card mb-3">
                                    <CardBody>
                                        <h6 className="fs-24 mb-3 text-blakish">Order Summary</h6>

                                        <span className="separator mt-2 mb-4"></span>
                                        {orderTrack?.productOrderDTO?.length > 0 && orderTrack?.productOrderDTO?.map((step, idx) => (
                                            <div className="summary-item d-flex justify-content-between fs-18 mb-3 text-gray" key={idx}>
                                                <span>{step.Quantity} <span className="mx-3">x</span> {step.ProductName}</span>
                                                <span>${step.Total} </span>
                                            </div>
                                        ))}

                                        <span className="separator mt-2 mb-4"></span>

                                        <div className="summary-item d-flex justify-content-between fs-18 mb-3 text-gray">
                                            <span className="text-gray">Sub Total</span>
                                            <span className="fs-18 text-blakish fw-600">${(orderTrack?.SubTotal)}</span>
                                        </div>
                                        <div className="summary-item d-flex justify-content-between fs-18 mb-3 text-gray mb-2">
                                            <span className="text-gray">Tax 15%</span>
                                            <span className="fs-18 text-blakish fw-600">${(orderTrack?.OrderTaxTotal)}</span>
                                        </div>

                                        <span className="separator mt-2 mb-4"></span>

                                        <div className="summary-item d-flex justify-content-between fs-20 text-blakish fw-600">
                                            <span>Grand Total</span>
                                            <span>${(orderTrack?.TotalAmount)}</span>
                                        </div>
                                    </CardBody>
                                </div>

                                {/* Need Help Section */}
                                <div className="help-card">
                                    <CardBody>
                                        <h4 className="fw-600 fs-30 mb-2">Need Help?</h4>
                                        <div className="text-white mb-4 fs-18">
                                            Have a question or need quick assistance?<br />We're here for you.
                                        </div>

                                        <a href="tel:+18025554321" className="help-btn mb-2 w-100">
                                            <i className="ri-phone-line me-1 fs-18 fw-400"></i> CALL RESTAURANT
                                        </a>

                                        <button onClick={() => history("/support")} className="help-btn-outline w-100">
                                            <i className="ri-customer-service-2-line me-1 fs-18 fw-400"></i> CONTACT SUPPORT
                                        </button>
                                    </CardBody>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            }
        </>
    )
}

export default TrackOrder;